import React from 'react';
import { useTranslation } from 'react-i18next';
import { useApolloClient } from '@apollo/client';
import Select, {
  IProps as ISelectProps,
  IValue,
  IValues,
} from './_module/Select';
import {
  IKeywordClassificationQueryData,
  IKeywordClassificationVarsPartial,
  keywordClassificationQuery,
} from '../../../graphql/query/keywordClassification/useKeywordClassificationQuery';

export default function SelectSearchClassification<
  TValue extends IValue | IValues
>(props: ISelectProps<TValue>) {
  const { t } = useTranslation();
  const client = useApolloClient();
  const {
    creatable,
    disabled,
    label,
    onChange,
    placeholder,
    value,
    menuPosition,
    required,
    margin,
    error,
    fullWidth,
    helperText,
    isMulti,
  } = props;

  return (
    <Select<TValue>
      creatable={creatable}
      isMulti={isMulti}
      async
      isClearable
      loadOptions={async (input) => {
        const { data } = await client.query<
          IKeywordClassificationQueryData,
          IKeywordClassificationVarsPartial
        >({
          query: keywordClassificationQuery(`
                _id
                name
              `),
          variables: {
            search: {
              name: input,
            },
            limit: 8,
          },
        });

        if (data && data.keywordClassifications) {
          return data.keywordClassifications.items.map(
            (keywordClassification) => ({
              label: keywordClassification.name,
              value: keywordClassification._id,
            })
          );
        }

        return [];
      }}
      menuPosition={menuPosition}
      label={label}
      required={required}
      margin={margin}
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      helperText={helperText}
      value={value}
      onChange={onChange}
      placeholder={
        placeholder ||
        t('insert_relevant__type__', { type: t('brand', { count: 2 }) })
      }
    />
  );
}
